import React from "react";
import PropTypes from "prop-types";
import {useValue} from "@morningtrain/react-resources";
import {observer} from "mobx-react";

function Boolean(props) {
    const {name, defaultValue} = props;

    let value = useValue(name, defaultValue);

    /// Bool casting
    value = value === 'false' ? false : value;
    value = value === 'true' ? true : value;
    value = !!value;

    if (props.style === 'dot') {
        return (
            <div className={"dot " + (value ? "active" : "")}/>
        );
    }

    if (props.style === 'text') {
        return value ? props.trueText : props.falseText;
    }

    return value;
}

Boolean.defaultProps = {
    defaultValue: null,
    style: 'text',
    trueText: 'Yes',
    falseText: 'No',
};

Boolean.propTypes = {
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.any,
    style: PropTypes.oneOf(['text', 'dot']),
    trueText: PropTypes.node,
    falseText: PropTypes.node,
};

export default observer(Boolean);
